import React from 'react'
import CompanyLogo from './CompanyLogo'
import Modal from './Modal'
import { Skeleton } from '@mui/material'
import styles from './CompanyInfo.module.scss'

export default function CompanyDescription({tickerInfo, modal, setModal, ticker}){
    const closeModal = () => setModal(false)

    return(
        <Modal handleClose={closeModal} open={modal} title="Company's description">
            <div className={styles['modal-header']}>
                <CompanyLogo image={tickerInfo.image} website={tickerInfo.website } ticker={ticker} size={38}/>
                <h1>{tickerInfo.companyName}</h1>
            </div>
            <div className={styles['company-description']}>
                {tickerInfo.description ?? <Skeleton width='100%' height='100px'/>}
            </div>
        </Modal>
    )
}